export const BLUEPRINT_TABS = {
  BASIC_CONFIGS: {
    label: 'Basic Config',
    value: 'basic-configs',
  },
  HOST_CONFIGS: {
    label: 'Host and Network Configuration',
    value: 'host-configs',
  },
  PERSISTENT_STORAGE_CONNECTIVITY: {
    label: 'Persistent Storage Connectivity',
    value: 'persistent-storage-connectivity',
  },
  CLUSTER_DEFAULTS: {
    label: 'Customize Cluster Defaults',
    value: 'cluster-defaults',
  },
}

export const networkingTypeRadioOptions = [
  {
    value: 'ovn',
    label: 'Open Virtual Network (OVN)',
    info: 'Use OVN for networking backend',
  },
  {
    value: 'ovs',
    label: 'Open vSwitch (OVS)',
    info: 'Use OVS for networking backend',
  },
]

export enum ImageLibraryStorageType {
  LOCAL_FILESYSTEM = 'local_filesystem',
  SHARED_FILESYSTEM = 'shared_filesystem',
  VOLUME_TYPE = 'volume_type',
}

export const imageLibraryStorageTypeOptions = [
  {
    value: ImageLibraryStorageType.LOCAL_FILESYSTEM,
    label: 'Local File System',
  },
  {
    value: ImageLibraryStorageType.SHARED_FILESYSTEM,
    label: 'Shared File System',
  },
  {
    value: ImageLibraryStorageType.VOLUME_TYPE,
    label: 'Volume Type',
  },
]

export const defaultImageLibraryLocation = '/var/opt/imagelibrary/data'
export const defaultVmStoragePath = '/opt/data/instances'
